import '../../../vendor/matilda_core_front/loader_assets.js'

import '../style/main.scss'
import '../scripts/main.js'